module.exports = __webpack_public_path__ + "img/ouch-thumbnail.6619d739.png";